<!--
BEDROCK Core
Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
-->

<!Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
-->

<!Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
-->

<template>

    <EntityForm :entity="entity" :model="{}" @submit="$emit('create', $event)" />

</template>

<script setup>

import { reactive } from "vue"

const props = defineProps({
    entity: Object
})

const emit = defineEmits(["create"])

const model = reactive({})

function submit() {

    emit("create", model)

}

</script>